(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-yori-section-caution-modal"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('custom-yori-caution-trigger')) {
  class CustomYoriCautionTrigger extends HTMLElement {
    constructor() {
      super();
      this.btn = this.querySelector('.custom-yori-caution-btn');
      this.modal = this.querySelector('.custom-yori-modal-overlay');
      this.closeBtn = this.querySelector('.custom-yori-modal-close');

      this.btn.addEventListener('click', () => this.open());
      this.closeBtn.addEventListener('click', () => this.close());
      
      this.modal.addEventListener('click', (e) => {
        if (e.target === this.modal) this.close();
      });

      document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && this.modal.hasAttribute('open')) {
          this.close();
        }
      });
    }

    open() {
      this.modal.showModal();
      document.body.classList.add('modal-open');
    }

    close() {
      this.modal.close();
      document.body.classList.remove('modal-open');
    }
  }

  customElements.define('custom-yori-caution-trigger', CustomYoriCautionTrigger);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-yori-section-product-showcase"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('custom-yori-event-modal')) {
  class CustomYoriEventModal extends HTMLElement {
    constructor() {
      super();
      this.overlay = this.querySelector('.custom-yori-modal-overlay');
      this.container = this.querySelector('.custom-yori-modal-container');
      this.closeBtn = this.querySelector('.custom-yori-modal-close');
      this.mainImage = this.querySelector('.custom-yori-modal-main-image img');
      this.thumbs = this.querySelectorAll('.custom-yori-modal-thumbs img');

      this.closeBtn.addEventListener('click', () => this.close());
      this.overlay.addEventListener('click', (e) => {
        if (e.target === this.overlay) this.close();
      });

      this.thumbs.forEach(thumb => {
        thumb.addEventListener('click', () => {
          this.mainImage.src = thumb.getAttribute('data-main-url') || thumb.src;
          this.mainImage.alt = thumb.alt;
        });
      });

      this.tabTriggers = this.querySelectorAll('.custom-yori-tab-trigger');
      this.tabPanels = this.querySelectorAll('.custom-yori-tab-content');

      this.tabTriggers.forEach(trigger => {
        trigger.addEventListener('click', (e) => {
          e.preventDefault();
          e.stopPropagation();
          const currentScroll = this.container.scrollTop;
          const tabId = trigger.getAttribute('data-tab');
          this.tabTriggers.forEach(t => t.classList.remove('is-active'));
          trigger.classList.add('is-active');
          this.tabPanels.forEach(panel => {
            if (panel.getAttribute('data-tab-panel') === tabId) {
              panel.classList.add('is-active');
            } else {
              panel.classList.remove('is-active');
            }
          });
          this.container.scrollTop = currentScroll;
        });
      });

      document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && this.overlay.classList.contains('is-open')) {
          this.close();
        }
      });
    }

    open() {
      this.preloadImages();
      this.overlay.classList.add('is-open');
      document.body.classList.add('modal-open');
      this.overlay.setAttribute('aria-hidden', 'false');
    }

    preloadImages() {
      this.thumbs.forEach(thumb => {
        const url = thumb.getAttribute('data-main-url');
        if (url) {
          const img = new Image();
          img.src = url;
        }
      });
    }

    close() {
      this.overlay.classList.remove('is-open');
      document.body.classList.remove('modal-open');
      this.overlay.setAttribute('aria-hidden', 'true');
    }
  }

  customElements.define('custom-yori-event-modal', CustomYoriEventModal);
}

document.addEventListener('DOMContentLoaded', () => {
  const productCards = document.querySelectorAll('.custom-yori-product-card');
  productCards.forEach(card => {
    card.addEventListener('click', () => {
      const productId = card.getAttribute('data-product-id');
      const modal = document.querySelector(`custom-yori-event-modal[data-modal-id="${productId}"]`);
      if (modal) {
        modal.open();
      }
    });
  });
});

  } catch(e) { console.error(e); }
})();
})();
